import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import draftToHtml from 'draftjs-to-html';
import { Parser } from 'html-to-react';

import { SECTION_TYPE, FETCH_STATUS } from '../../Constants';
import { changeTheme, setPageTitle, capitalize } from '../../Utils/otherUtils';
import CareerButton from './CareerButton';
import EmbeddedVideoComponent from '../EmbeddedVideoComponent';
import FAQComponent from '../FAQComponent';
import GdprModal from './GdprModal';
import ImageSectionComponent from '../ImageSectionComponent';
import LoadingIndicatorComponent from '../LoadingIndicatorComponent';
import SubscribeModal from './SubscribeModal';
import QuestionModal from './QuestionModal';
import { openQuestionModal, openSubscriptionModal } from '../../Actions/CareerActions';
import {
  closeCommuteModal,
  openCommuteModal,
} from '../../Actions/ToggleActions';

import mailIcon from '../../Images/Icons/icon_contact_white.svg';
import searchIcon from '../../Images/Icons/icon_search_white.svg';

const Career = (props) => {
  const dispatch = useDispatch();

  const { careerName, municipalityName } = props.match.params;
  const career
    = useSelector(state => state.Career.careers.find(c => c.careerName === careerName));
  const {
    status, gdprModalIsOpen, subscriptionModalIsOpen, questionModalIsOpen,
  } = useSelector(state => state.Career);
  const theme = useSelector(state => state.MunicipalityReducer.theme);
  const {
    language, text: { careerPage: pageText },
  } = useSelector(state => state.Language);

  const htmlToReactParser = new Parser();

  useEffect(() => {
    dispatch(closeCommuteModal());
  }, []);

  useEffect(() => {
    if (status === FETCH_STATUS.FAILED) {
      dispatch(push(`/sv/${municipalityName}`));
    }
    if (status === FETCH_STATUS.SUCCEEDED && !career) {
      dispatch(push(`/sv/${municipalityName}`));
    }
    if (status === FETCH_STATUS.SUCCEEDED && career) {
      setPageTitle(`Välkommen hit - ${career.menuContent[language].name} ${capitalize(municipalityName)}`);
    }
  }, [status]);

  useEffect(() => {
    changeTheme(theme);
  }, [theme]);

  const parseTextSection = (section) => {
    const textToParse = section.content[language];
    return (
      <div key={section.index} className="main-text-content">
        <p><strong>{textToParse.header}</strong></p>
        {htmlToReactParser.parse(draftToHtml(textToParse.text))}
      </div>
    );
  };

  const renderSections = () => {
    const parseSections = sections =>
      sections.map((section) => {
        const divider = section.index !== sections.length;
        switch (section.type) {
          case SECTION_TYPE.TEXT:
            return parseTextSection(section, language);
          case SECTION_TYPE.IMAGES:
            return (<ImageSectionComponent
              municipality={municipalityName}
              section={section}
              divider={divider}
              key={section.index}
            />);
          case SECTION_TYPE.VIDEO:
            return (<EmbeddedVideoComponent
              section={section}
              key={section.index}
            />);
          case SECTION_TYPE.FAQ:
            return (<FAQComponent
              content={section.content[language]}
              divider={divider}
              key={section.index}
            />);
          default:
            return '';
        }
      });

    const sortedSections = career.content.section.sort((s1, s2) => s1.index - s2.index);
    const sections = parseSections(sortedSections);

    return (
      <div className="white-bg">
        <div className="top-btn">
          <input
            className="btn close"
            type="button"
            onClick={() => {
              dispatch(push(`/${language}/${municipalityName}`));
              dispatch(openCommuteModal());
            }}
          />
        </div>
        <div className="header">
          <h1>{career.content.topContent[language].header}</h1>
        </div>
        <div className="preamble main-text-content">
          {htmlToReactParser.parse(draftToHtml(career.content.topContent[language].text))}
        </div>
        <div>
          {sections}
        </div>
      </div>
    );
  };

  return (
    status !== FETCH_STATUS.SUCCEEDED || !career ?
      <LoadingIndicatorComponent /> :
      <article className="full-view-page-wrapper" aria-label={career.menuContent[language].name}>
        {renderSections()}
        <CareerButton
          icon={mailIcon}
          onClick={() => { dispatch(openSubscriptionModal()); }}
          text={pageText.registerMail}
          topPosition="25px"
          leftPosition="220px"
        />
        <CareerButton
          icon={searchIcon}
          onClick={() => { dispatch(openQuestionModal()); }}
          text={pageText.submitQuestion}
          topPosition="25px"
          leftPosition="25px"
        />
        {
          questionModalIsOpen ?
            <QuestionModal email={career.email} /> :
            null
        }
        {
          subscriptionModalIsOpen ?
            <SubscribeModal careerId={career.careerId} /> :
            null
        }
        {gdprModalIsOpen ? <GdprModal content={career.gdprContent} /> : null}
      </article>
  );
};

export default Career;



// WEBPACK FOOTER //
// ./src/Components/Career/Career.js